
//import React from 'react';

const DateToday = () => {
    let date = new Date().toDateString();
    return date;
}

export {DateToday};